<template>
  <div
    class="whs-hero"
    @click.self="isFixed && $store.commit('hero/minify')"
    :class="{'is-fixed': isFixed && !isMinified}"
  >
    <div
      v-show="isMinified"
      class="whs-hero-minified-container"
      @click="$store.commit('hero/minify', false)"
    >
      <div
        class="whs-hero-minified-direction"
        v-if="direction"
      >{{ direction.country || direction.region_name }}, {{ direction.name }}</div>
      <div class="whs-small">{{ checkInOut }}</div>
      <div class="whs-small">{{ nightsAdultsAlt }}</div>
      <div class="whs-hero-minified-change">Изменить</div>
    </div>
    <div v-show="!isMinified" class="whs-hero__container">
      <div class="whs-hero__control--direction" ref="query">
        <div class="whs-hero__label" v-show="query">Направление</div>
        <input
          type="text"
          ref="input"
          v-model.trim="query"
          placeholder="Впишите регион или отель"
          class="whs-hero__input whs-hero__input--direction"
          :class="{'is-set': hasDirection}"
          @keyup.down="focusResult(1)"
          @keyup.up="focusResult(-1)"
          @keyup.enter="setDirectionIfFocused"
        />
        <div v-if="hasDirection" class="whs-hero__input-nullifier whs-icon" @click="nullify"></div>
        <transition name="fade">
          <div v-if="hasResult" class="whs-hero__result-container">
            <div class="whs-hero__result-title-region" v-show="regions.length > 0">Регионы</div>
            <div
              class="whs-hero__result-region whs-icon-left"
              v-for="(region, index) in regions"
              v-bind:key="region.id"
              :class="{'is-focused': index === focus}"
              @click="setDirection({...region, params: {region_id: region.id} })"
            >{{ region.name }}, {{ region.country }}</div>
            <div class="whs-hero__result-title-hotel" v-show="hotels.length > 0">Отели</div>
            <div
              class="whs-hero__result-hotel whs-icon-left"
              v-for="(hotel, index) in hotels"
              :class="{'is-focused': index + regions.length === focus}"
              v-bind:key="hotel.id"
              @click="setDirection({...hotel, params: {ids: [hotel.id]}})"
            >{{ hotel.name }}, {{ hotel.region_name }}</div>
          </div>
        </transition>
      </div>

      <Calendar ref="Calendar" />
      <Guests />

      <div class="whs-hero__control">
        <div
          class="whs-hero__submit"
          :class="{'is-disabled': isLoading}"
          @click="submitForm"
          @keyup.enter="submitForm"
        >{{isLoading ? 'Идет поиск' : 'Найти отели'}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Calendar from '../components/Calendar.vue';
import Guests from '../components/Guests.vue';

export default {
  name: 'Hero',
  components: {
    Calendar,
    Guests
  },

  props: {
    context: String
  },

  data: function() {
    return {
      focus: null
    };
  },

  created: function() {
    const vm = this;
    window.addEventListener('click', e => {
      if (
        vm.$store.state.hero.query.length === 0 ||
        (vm.$refs.query && vm.$refs.query.contains(e.target)) ||
        vm.$store.state.hero.direction
      )
        return;
      vm.$store.commit('hero/updateQuery', '');
      vm.$store.commit('hero/updateQueryList');
    });

    const scrollIntoWhsView = e => {
      if (vm.$route.path !== '/') return;
      if (!document.getElementById('whs').contains(e.target)) return;

      document.getElementById('whs').scrollIntoView();
      window.removeEventListener('click', scrollIntoWhsView);
    };
    window.addEventListener('click', scrollIntoWhsView);
  },

  mounted: function() {
    if (this.$route.path === '/') {
      // if (this.$store.getters.context !== 'main') this.$refs.input.focus();
    } else {
      if (this.$parent.$options.name !== 'Main')
        this.$store.commit('hero/minify');
    }
  },

  computed: {
    ...mapState('hero', [
      'list',
      'direction',
      'adults',
      'children',
      'isMinified',
      'checkinDate',
      'checkoutDate'
    ]),
    ...mapGetters('hero', ['checkin', 'checkout', 'checkInOut']),
    query: {
      get() {
        return this.direction
          ? this.direction.name
          : this.$store.state.hero.query;
      },
      set(value) {
        this.$store.commit('hero/updateQuery', value);
      }
    },
    hotels() {
      return this.list.hotels;
    },
    regions() {
      return this.list.regions;
    },
    hasResult() {
      return this.list.regions.length > 0 || this.list.hotels.length > 0;
    },
    hasDirection() {
      return this.direction !== null;
    },
    isLoading() {
      return this.$store.state.hotels.loading;
    },
    nightsAdultsAlt() {
      const nights = (this.checkoutDate - this.checkinDate) / 86400000;
      const guests = this.adults + this.children.length;
      const nightsString =
        nights === 1 ? 'ночь' : nights < 5 ? 'ночи' : 'ночей';
      const guestsString = guests === 1 ? 'гостя' : 'гостей';
      return `на ${nights} ${nightsString} для ${guests} ${guestsString}`;
    },
    isFixed() {
      return this.$parent.$options.name !== 'Main';
    }
  },

  watch: {
    query: function(value) {
      if (!this.direction) this.$store.dispatch('hero/getQueryList');
      if (value && value.length === 0) this.focus = null;
    }
  },

  methods: {
    setDirection(direction) {
      this.$store.commit('hero/updateDirection', direction);
    },
    focusResult(index) {
      if (!this.hasResult || !index) return (this.focus = null);
      const resultLength = this.hotels.length + this.regions.length;
      if (this.focus === null) {
        this.focus = index > 0 ? 0 : resultLength - 1;
      } else {
        this.focus =
          this.focus + index >= resultLength
            ? 0
            : this.focus + index < 0
            ? resultLength - 1
            : this.focus + index;
      }
    },
    setDirectionIfFocused() {
      if (this.focus === null) return;

      let direction;
      if (this.focus > this.regions.length - 1) {
        const hotel = this.hotels[this.focus - this.regions.length];
        direction = { ...hotel, params: { ids: [hotel.id] } };
      } else {
        const region = this.regions[this.focus];
        direction = { ...region, params: { region_id: region.id } };
      }
      this.$store.commit('hero/updateDirection', direction);
      this.focus = null;
      this.$refs.input.blur();
    },
    nullify() {
      this.focus = null;
      this.$store.commit('hero/updateDirection');
      this.$refs.input.focus();
    },
    submitForm() {
      if (this.isLoading) return false;
      if (!this.direction) return this.$refs.input.focus();
      if (!this.checkout)
        return setTimeout(() => {
          this.$refs.Calendar.$refs.input.focus();
          this.$refs.Calendar.$refs.input.click();
        }, 100);
      const query = {
        checkin: this.checkin,
        checkout: this.checkout,
        adults: this.adults,
        ...this.direction.params
      };
      if (this.children.length > 0) query.children = this.children;

      this.$store.commit('hero/updateNightsAdults');

      if (!this.direction.params.ids) {
        this.$router.push({ path: '/hotels', query });
      } else {
        this.$router.push({
          path: `/hotels/${this.direction.params.ids}`,
          query
        });
      }

      if (this.$route.path === '/hotels')
        this.$store
          .dispatch('hotels/getHotels', query)
          .then(() => this.$store.dispatch('hotels/getHotelInfo'))
          .then(() => this.$store.dispatch('getLocation'));

      if (this.$parent.$options.name !== 'Main')
        this.$store.commit('hero/minify');
    }
  }
};
</script>


<style>
.whs-hero {
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.whs-hero-minified-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 18px;
  /* margin: 8px; */
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  position: relative;
  cursor: pointer;
}
.whs-hero-minified-direction {
  font-size: 16px;
  font-weight: 500;
}
.whs-hero-minified-change {
  position: absolute;
  right: 18px;
  bottom: 8px;
  color: var(--color-main);
  font-weight: 500;
}
.whs-hero__container {
  padding: 18px 12px 24px;
  width: 100%;
  max-width: 1000px;
  /* background-color: var(--color-bg); */
  background: linear-gradient(var(--color-bg-dark), var(--color-bg));
  border-top: 8px solid var(--color-alt-5);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  user-select: none;
}
.whs-hero.is-fixed {
  position: fixed;
  z-index: 2;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--color-text-5);
  padding-top: 48px;
}
.whs-hero__label {
  padding: 4px 12px;
  position: absolute;
  font-size: 11px;
  color: var(--color-text-5);
  font-weight: 600;
  pointer-events: none;
}
.whs-hero__submit {
  width: 100%;
  background: var(--color-button);
  outline: none;
  padding: 14px 20px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
}
.whs-hero__submit:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
}
.whs-hero__submit.is-disabled,
.whs-hero__submit.is-disabled:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-alt);
  opacity: 0.5;
  cursor: wait;
}
.whs-hero__input {
  width: 100%;
  background-color: #fff;
  outline: none;
  line-height: 16px;
  padding: 20px 12px 8px;
  border: 1px solid var(--color-alt-5);
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px;
}
.whs-hero__input.is-set {
  background-color: var(--color-bg);
  transition: background-color 0.3s;
}
.whs-hero__input.is-set:hover {
  background-color: #fff;
  transition: background-color 0.3s;
}
.whs-hero__input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.whs-hero__input:focus::placeholder {
  color: var(--color-alt);
}
.whs-hero__input:focus {
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
[class*='whs-hero__control'] {
  position: relative;
  padding: 8px;
}
.whs-hero__result-container {
  z-index: 1;
  width: calc(100% - 16px);
  position: absolute;
  background-color: #fff;
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.whs-hero__input-nullifier,
.whs-hero__select-simulator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 12px 13px;
  cursor: pointer;
  transition: 0.3s;
}
.whs-hero__input-nullifier {
  background-color: var(--color-bg);
}
.whs-hero__select-simulator {
  pointer-events: none;
}
.whs-hero__input-nullifier:before,
.whs-hero__select-simulator:before {
  content: '\f00d';
  color: var(--color-alt);
  font-size: 18px;
}
.whs-hero__select-simulator:before {
  content: '\f078';
  display: block;
}
.whs-hero__select-simulator.open:before {
  transform: rotate(-180deg);
  transition: transform 0.3s;
}
.whs-hero__input-nullifier:hover:before {
  color: var(--color-main);
}

.whs-hero__control--direction {
  flex: 3 1 250px;
  /* min-width: 300px; */
}
.whs-hero__result-hotel,
.whs-hero__result-region {
  display: flex;
  padding: 4px 12px;
  min-height: 32px;
  cursor: pointer;
  border-bottom: 1px solid var(--color-bg-dark);
  transition: 0.3s ease-out;
}
.whs-hero__result-hotel:last-child {
  border-bottom: none;
}
.whs-hero__result-hotel.is-focused,
.whs-hero__result-region.is-focused,
.whs-hero__result-hotel:hover,
.whs-hero__result-region:hover {
  background-color: var(--color-bg);
}
.whs-hero__result-hotel:before {
  content: '\f594';
  line-height: 20px;
  color: var(--color-bg-warm);
}
.whs-hero__result-region:before {
  content: '\f5a0';
  line-height: 20px;
  color: var(--color-bg-cold);
}
.whs-hero__result-title-hotel,
.whs-hero__result-title-region {
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-bg-cold);
}
.whs-hero__result-title-hotel {
  color: var(--color-bg-warm);
}
</style>

